const getters = {
  picAddr: state => state.uploadAddr,
  parentActiveTab: state => state.parentActiveTab,
  childActiveTab: state => state.childActiveTab,
  menus: state => state.menus,
  cosId: state => state.cosId,
  searchinfo: state => state.searchinfo,
  obWebUrl: state => state.obWebUrl,
  webLoginUser: state => state.webLoginUser,
  cos: state => state.cos
}
export const province = (state) => {
  let list = state.public.areaTree
  return list
}
export default getters
